<div class="page">
  <header class="page__header">
    <fv-logo class="page__logo" size="sm" [srcFull]="config().logoSrc" />
    <h1 class="page__title">{{ config().title }}</h1>
  </header>

  <main class="page__main">
    <fv-status-banner [banner]="store.banner()" />

    <ul class="page__meta" [attr.data-cy]="qaKeys.MetaRow">
      @if (store.hasLoaded()) {
        <li>{{ copy.labels.updated }} {{ updatedLabel() }}</li>
        <li aria-hidden="true">{{ copy.labels.refreshIn }} {{ store.secondsToRefresh() }}s</li>
        @if (store.isDataDelayed()) {
          <li class="page__warning">{{ copy.labels.dataAge }} {{ dataAgeLabel() }}</li>
        }
      }
    </ul>

    @if (store.issues().length > 0) {
      <section aria-labelledby="issues-title">
        <h2 id="issues-title" class="page__issues-title">{{ copy.summary.issuesTitle }}</h2>
        <fv-elevated class="page__issues" padding="none" elevation="l1" radius="sm" [attr.data-cy]="qaKeys.Issues">
          @for (issue of store.issues(); track issue.key) {
            <fv-status-card
              [label]="issue.label"
              [state]="issue.state"
              [affectedServices]="issue.affectedServices"
              [lastCheckedAt]="issue.lastCheckedAt"
              [sinceAt]="issue.sinceAt"
              [error]="issue.error"
              [now]="store.now()" />
          }
        </fv-elevated>
      </section>
    }

    @if (isSummaryVisible()) {
      <p class="page__summary" [class.page__summary--ok]="store.issues().length === 0" [attr.data-cy]="qaKeys.Summary">
        {{ summaryLabel() }}
      </p>
    }

    @if (store.hasReport()) {
      <fv-status-report
        [lines]="store.reportLines()"
        [isUnavailable]="store.isReportUnavailable()"
        [isTruncated]="store.isReportTruncated()"
        [now]="store.now()" />
    }
  </main>

  <footer class="page__footer">{{ footerLabel() }}</footer>
</div>
